// extracted by mini-css-extract-plugin
export default {"container":"TopicBreadcrumbs-module__container--TbfFU","animatedBackground":"TopicBreadcrumbs-module__animatedBackground--mVu0V"};